module.exports = __webpack_public_path__ + "static/media/youtube.73ed8700.svg";